import { AfterViewInit, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '@appShared/services/common.service';
import {
  ShareholderEditSection_,
  AdminService,
  ShareholderEditSectionData
} from '@appShared/services/admin.service';
import { IShareholder } from '@appShared/interfaces/[Model-based]/shareholder.interface';
import { ShareholderEditComponent } from '../shareholder-edit.component';
import * as _ from 'lodash';

@Component({
  templateUrl: './shareholder-edit-modal.component.html',
   styleUrls: ['./shareholder-edit-modal.component.less'],
   imports: [ShareholderEditComponent],
  /* eslint-disable @angular-eslint/no-host-metadata-property */
  host: {
    '[style.display]': '"flex"',
    '[style.flex-direction]': '"column"',
    '[style.overflow]': '"hidden"'
  }
  /* eslint-enable @angular-eslint/no-host-metadata-property */
})
export class ShareholderEditModalComponent implements AfterViewInit {
  @Input() shareholder: IShareholder;
  @Input() canEdit: boolean;
  @Input() closeFunction: () => void | null;
  @Input() dismissFunction: () => void | null;
  @Input() saveFunction: () => void | null;
  @Input() refreshGrid: () => void;
  ShareholderEditSection_ = ShareholderEditSection_;

  constructor(
    private _activeModal: NgbActiveModal,
    private _commonService: CommonService,
    private _adminService: AdminService
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this._refreshShareholder(this.shareholder);
    }, 0);
  }

  /*
   * private methods
   * */

  private _refreshShareholder(shareholder?: IShareholder): void {
    const setShareholder = (refreshedShareholder?: IShareholder) => {
      this.shareholder = refreshedShareholder || shareholder;
      setTimeout(() => {
        this.goToSection();
      }, 0);
    };

    /* if existing shareholder - get fresh data */
    if (shareholder.id) {
      this._adminService
        .getShareholder(shareholder.id)
        .then(refreshedShareholder => {
          setShareholder(refreshedShareholder);
        })
        .catch(() => {
          this._activeModal.close(this.closeFunction);
        });
    } else {
      setShareholder();
    }
  }

  /*
   * public methods
   * */

  goToSection(section?: ShareholderEditSection_): void {
    section = section || ShareholderEditSection_.basicInfo;

    /* if new item, then scroll to basic data section */
    if (!this.shareholder.id) {
      section = ShareholderEditSection_.newEmployeeInfo;
    }

    setTimeout(() => {
      this._commonService.scrollToModalAnchor(
        `shareholder-edit-section-${section}`
      );
    }, 0);
  }

  shareholderUpdated(shareholderEditSection: ShareholderEditSectionData): void {
    // this.currentItem = { ...this.currentItem, ...item };
    // let itemIndex = this.itemCollection.findIndex(i => i.id === item.id);
    // if (itemIndex !== -1) {
    //  this.itemCollection.splice(itemIndex, 1, item);
    // }
    this.shareholder = {
      ...this.shareholder,
      ...shareholderEditSection.shareholder
    };

    if (shareholderEditSection.refresh) {
      this.refreshGrid();
    }
  }

  dismiss(): void {
    this._activeModal.dismiss(this.closeFunction);
  }

  close(): void {
    this._activeModal.close(this.dismissFunction);
  }
}
